import { httpClient } from '@/services/http/httpClient'

export type InviteUserProject = {
  inviteeId: string
  projectId: string
  type: string
}

export async function inviteUserProject(params: InviteUserProject) {
  await httpClient.post(`/projects/project-invites`, {
    inviteeId: params.inviteeId,
    permission: params.type,
    projectId: params.projectId,
  })
}
